import { Injectable } from "@angular/core";

export type Stage = "loc" | "dev" | "tst" | "prd";

export interface AppConfig {
  stage: Stage;
  previewMode: boolean;
}

@Injectable({ providedIn: "root" })
export class RuntimeConfigService {
  private config: AppConfig = { stage: "loc", previewMode: false };

  load(cfg: AppConfig): void {
    this.config = cfg;
  }

  get previewMode(): boolean {
    return this.config.previewMode;
  }

  get stage(): Stage {
    return this.config.stage;
  }

  get softwareStatusLabel(): string | undefined {
    const labels: Record<Stage, string | undefined> = {
      loc: "LOCAL",
      dev: "DEV",
      tst: "TEST",
      prd: undefined,
    };
    const base = labels[this.config.stage];
    if (!base) return undefined;
    return this.config.previewMode ? `${base} Preview` : base;
  }
}
